module.exports = __webpack_public_path__ + "static/assets/d65fffc0839e1dca316f2f1e62b3fc85.svg";